import React, { Component } from 'react'
import ProTypes from 'prop-types'
import publicIp from "public-ip";
import ReactHtmlParser from 'react-html-parser';
import { req_list_oss_replyContent } from '../../api'

export default class Main extends Component {
    // 基礎通用參數 //////////////////////////////////////////////  
    state = {
        initView: true,
        loading: false,
        items: null,
        errMsg: null,
        ip: '',
        total: 0
    }

    static propTypes = {
        searchName: ProTypes.string.isRequired
    }

    componentDidMount = () => {
        (async () => {
            const ip = await publicIp.v4()
            this.setState({ ip })
        })();
    }

    //當組件接收到新的ProTypes屬性值
    componentWillReceiveProps(newProps) {
        //指定了新的searchName需要請求
        const { searchName } = newProps
        // 更新狀態(請求中)
        this.setState({
            initView: false,
            loading: true,
            items: null
        })

        this.api_list_replyContent(searchName, this.state.ip)
    }


    // 遠端數據處理 //////////////////////////////////////////////

    api_list_replyContent = async (searchName, sourceIp) => {
        const result = await req_list_oss_replyContent(searchName, sourceIp)
        if (result.total > 0) {
            const content = result.data
            const rows = content.map((item, index) => { return { service_title: item.serviceTitle, service_description: item.serviceDescription, service_department: item.serviceDepartment, service_staff: item.serviceStaffName, service_telephone: item.serviceTelephone, handling_time: item.handlingTime, applicable_objects: item.applicableObjects, address: item.locationAddress, location: item.locationName, northLatitude: item.northLatitude, eastLongitude: item.eastLongitude } })
            this.setState({ loading: false, items: rows })
        } else {
            const content = null
            this.setState({ loading: false, items: content })
        }
    }    

    keySingleRender(text, key) {
        if (key && text && typeof text === 'string' && typeof key === 'string') {
          const newTextArr = text.split("").map(t => {
            return key.toLowerCase().indexOf(t.toLowerCase()) > -1 ? `<Fragment class="redTip">${t}</Fragment>` : t;
          });
          const newText = newTextArr.join("");
          return (<span dangerouslySetInnerHTML={{ __html: newText }} />);
        } else {
          return text;
        }
      }

    render() {
        const { initView, loading, items, errMsg } = this.state
        const { searchName } = this.props
        if (initView) {
            //初始畫面
            return <div className="container-fluid"></div>
        } else if (loading) {
            // 正在載入中
            return <div className="container-fluid">
                <div className="text-center">
                    <button className="btn btn-light text-dark" type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> 查詢中 ......
                    </button>
                </div>
            </div>
        } else if (errMsg) {
            // 出現錯誤
            return <div className="container-fluid"><h2>{errMsg}</h2></div>
        } else {
            if (items) {
                return (
                    <div className="container-fluid">
                        <div id="accordion">
                            {
                                items.map((item, index) => {
                                    return (
                                        <div className="card " key={index} >
                                            <div className="card-header">
                                                <h5 className="mb-0">
                                                    <button className="btn btn-link" data-toggle="collapse" data-target={`#collapse${index}`} aria-expanded="true" aria-controls={`collapse${index}`} style={{textAlign:'left'}}>
                                                        <i className="fa fa-lightbulb-o" aria-hidden="true"></i> 諮詢項目：{this.keySingleRender(item.service_title, searchName)}
                                                    </button>
                                                </h5>
                                            </div>

                                            <div id={`collapse${index}`} className="collapse" aria-labelledby="heading" data-parent="#accordion">
                                                <div className="card-body">
                                                    <form>
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text"><i className="fa fa-users"></i></span>
                                                                <span className="input-group-text d-none d-sm-block">適用對象</span>
                                                            </div>
                                                            <input type="text" className="form-control" aria-describedby="applicable_objects" aria-label="適用對象" defaultValue={item.applicable_objects} />
                                                        </div>
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text"><i className="fa fa-tags"></i></span>
                                                                <span className="input-group-text d-none d-sm-block">相關說明</span>
                                                            </div>
                                                            <textarea className="form-control" aria-describedby="applicable_objects" aria-label="相關說明" rows="3" defaultValue={ReactHtmlParser(item.service_description)} />
                                                        </div>
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text"><i className="fa fa-cogs"></i></span>
                                                                <span className="input-group-text d-none d-sm-block">處理時間</span>
                                                            </div>
                                                            <input type="text" className="form-control" aria-describedby="handling_time" aria-label="處理時間" defaultValue={item.handling_time} />
                                                        </div>
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text"><i className="fa fa-university"></i></span>
                                                                <span className="input-group-text d-none d-sm-block">承辦單位</span>
                                                            </div>
                                                            <input type="text" className="form-control" aria-describedby="service_department" aria-label="承辦單位" defaultValue={item.service_department} />
                                                        </div>
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text"><i className="fa fa-address-card"></i> </span>
                                                                <span className="input-group-text d-none d-sm-block">承辦人員</span>
                                                            </div>
                                                            <input type="text" className="form-control" aria-describedby="service_staff" aria-label="承辦人員" defaultValue={item.service_staff} />
                                                        </div>
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text"><i className="fa fa-phone-square"></i></span>
                                                                <span className="input-group-text d-none d-sm-block">聯繫電話</span>
                                                            </div>
                                                            <input type="text" className="form-control" aria-describedby="service_telephone" aria-label="聯繫電話" defaultValue={item.service_telephone} />
                                                            <div className="input-group-append">
                                                                <span className="input-group-text"><a href={`tel:${item.service_telephone}`} className="btn btn-outline-danger btn-sm">通話</a></span>
                                                            </div>
                                                        </div>
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text"><i className="fa fa-map"></i></span>
                                                                <span className="input-group-text d-none d-sm-block">諮詢地點</span>
                                                            </div>
                                                            <input type="text" className="form-control" aria-describedby="service_telephone" aria-label="諮詢地點" defaultValue={`${item.location}(${item.address})`} />
                                                            <div className="input-group-append">
                                                                <span className="input-group-text"><a href={`https://www.google.com.tw/maps/place/${item.northLatitude},${item.eastLongitude}`} target="_blank" rel="noreferrer" className="btn btn-outline-danger btn-sm">前往</a></span>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>

                                    )
                                })
                            }
                        </div>
                    </div>
                )
            } else {
                return <div className="container-fluid"><h2>查無相關內容</h2></div>
            }


        }
    }
}
